import { Entity } from '../common-models/Entity';
import { OrderItem } from './OrderItem';

export class ProductRecipeLinkingRequestItem extends Entity {
  productRecipeLinkingRequestId: number;
  orderItemId?: number;
  orderItem?: OrderItem;
  shopifyOrderItemId?: number;
}